import { useCollaboratorsState } from '@components/ArtBoard/Collaboration/hooks/useCollaboratorsState'
import { useMediaQuery } from '@lib/hooks'

import { CollaborationViewersRest } from './components/CollaborationViewersRest'
import { CollaborationViewersStack } from './components/CollaborationViewersStack'
import css from './styles.module.css'

const PRIMARY_COUNT_TO_RENDER = 3
const PRIMARY_COUNT_TO_RENDER_MOBILE = 2

export const CollaborationViewers = () => {
  const collaborators = useCollaboratorsState()

  const lessThanTablet = useMediaQuery('screen and (max-width: 768px)')

  const restCount = lessThanTablet
    ? PRIMARY_COUNT_TO_RENDER_MOBILE
    : PRIMARY_COUNT_TO_RENDER

  const list = collaborators.slice(0, restCount)
  const rest = collaborators.slice(restCount)

  if (collaborators.length === 0) {
    return null
  }

  return (
    <>
      <div className={css.collaboration_viewers}>
        <CollaborationViewersStack collaborators={list} />
        <CollaborationViewersRest count={rest.length} />
      </div>
      <div className={css.collaboration_viewers_divider} />
    </>
  )
}
